
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Bar, mixins } from 'vue-chartjs'
import { ChartData, ChartOptions } from 'chart.js'

@Component
export default class BarChart extends Mixins(Bar, mixins.reactiveProp) {
  @Prop()
  public chartData!: ChartData;

  @Prop()
  public chartOptions!: ChartOptions;

  public mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  }
}
